import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useIdleTimer as idleTimer } from 'react-idle-timer';
import { saveData } from '../utils';

const useIdleTimer = (from) => {
  const IDLE_TIMEOUT = 60000;

  const startTime = useSelector(({ time }) => time.startTime);

  const navigate = useNavigate();

  return idleTimer({
    timeout: Number(IDLE_TIMEOUT),
    onIdle: async () => {
      if (from === 'quiz') saveData(startTime, null, 'incomplete');

      navigate('/');
    },
  });
};

export default useIdleTimer;
